document.addEventListener('DOMContentLoaded', () => {
  const checkbox = document.getElementById('grill-video__controler');
  const closeModal = document.querySelectorAll('[data-close-modal]');
  const videoSource = document.querySelector('.grill-video__modal-video');

  if (checkbox && videoSource) {
    const labels = document.querySelectorAll('label[for="grill-video__controler"]');
    labels.forEach(label => {
      label.addEventListener('click', () => {
        if (!checkbox.checked) {
          const dataUrl = label.getAttribute('data-url');
          if (dataUrl) {
            videoSource.setAttribute('src', dataUrl);
            videoSource.parentElement.load(); // Reload the video with the new source
          }
        }
      });
    });
  }

  if(closeModal) {
    closeModal.forEach(label => {
      label.addEventListener('click', () => {
        const video = document.querySelector('.grill-video__modal-video');
        video.pause();
      });
    });
  };

  function setupClassObserver(targetNode, classToWatch, nodeToModify, classToAdd) {
    const config = { attributes: true, attributeFilter: ['class'] };

    const callback = function(mutationsList, observer) {
      for(let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (targetNode.classList.contains(classToWatch)) {
            nodeToModify.classList.add(classToAdd);
          } else {
            nodeToModify.classList.remove(classToAdd);
          }
        }
      }
    };

    const observer = new MutationObserver(callback);

    observer.observe(targetNode, config);

    return observer;
  }

  const targetNode = document.querySelector('product-quick-add');
  const nodeToModify = document.querySelector('#videoModal');

  if(targetNode) {
    const observer = setupClassObserver(targetNode, 'is-visible', nodeToModify, 'product-quick-active');
  }
});
